/**
 * One "Complete the set" row. Its swatches pick the variant that row adds to the cart
 * and keep the row's photo, price and per-piece line in step. Nothing here touches the
 * main product on the page.
 */
class FaUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const swatch = event.target instanceof Element ? event.target.closest('.fa-upsells__swatch') : null;
    if (!(swatch instanceof HTMLButtonElement) || swatch.disabled) return;

    const { variantId, price, compare, perPiece, image } = swatch.dataset;
    if (!variantId) return;

    this.querySelectorAll('.fa-upsells__swatch').forEach((element) => {
      element.setAttribute('aria-pressed', String(element === swatch));
    });

    const input = this.querySelector('[data-fa-upsell-variant]');
    if (input instanceof HTMLInputElement) input.value = variantId;

    this.#setText('[data-fa-upsell-price]', price);
    this.#setText('[data-fa-upsell-compare]', compare);
    this.#setText('[data-fa-upsell-per-piece]', perPiece);

    const img = this.querySelector('[data-fa-upsell-image]');
    if (img instanceof HTMLImageElement && image) {
      img.removeAttribute('srcset');
      img.src = image;
    }
  };

  /**
   * @param {string} selector
   * @param {string | undefined} value
   */
  #setText(selector, value) {
    const element = this.querySelector(selector);
    if (element) element.textContent = value ?? '';
  }
}

if (!customElements.get('fa-upsell')) {
  customElements.define('fa-upsell', FaUpsell);
}
